import { PureComponent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape, MessageDescriptor } from 'react-intl';

import { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { ComponentLink as Link } from 'src/components/component-link';
import Breadcrumbs from 'src/sections/workspace/components/breadcrumbs';

import { messages } from './breadcrumbs.i18n';

type WorkspaceSettingsBreadcrumbsProps = {
  settingsHref: string;
  intl: IntlShape;
  additionalLinks?: {
    href: string;
    label: string | MessageDescriptor;
  }[];
};

class WorkspaceSettingsBreadcrumbs extends PureComponent<WorkspaceSettingsBreadcrumbsProps> {
  render() {
    const { intl, settingsHref, additionalLinks } = this.props;

    const text = intl.formatMessage(messages.index);

    return (
      <Breadcrumbs>
        <BreadcrumbsItem href={settingsHref} text={text} component={Link} />
        {additionalLinks &&
          additionalLinks.map(({ href, label }) => {
            const formatttedLabel =
              typeof label === 'string' ? label : intl.formatMessage(label);
            return (
              <BreadcrumbsItem
                key={href}
                href={href}
                text={formatttedLabel}
                component={Link}
              />
            );
          })}
      </Breadcrumbs>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(WorkspaceSettingsBreadcrumbs);
